import { createSelector } from 'reselect';
import { civilContestsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const civilContestsYearsSelector = createSelector([civilContestsSelector], (civilContests) =>
  extractDatesFromNestedItems(
    [civilContests.content],
    [
      {
        type: 'range',
        startField: 'startDate',
        endField: 'endDate',
      },
    ],
  ),
);
